import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Evento from "../components/evento"
import Cosa from "../components/cosa"
import Partecipare from "../components/partecipare"
// import WcIIC from "../components/wc-iic"
import DiventaSponsor from "../components/diventa-sponsor"
import Focus from "../components/focus"
// import Newsletter from "../components/newsletter"
import Banner from "../components/banner"


const EventoPage = ({ pageContext: { locale } }) => (
  <Layout locale={locale}>
    <SEO title="evento" bodyClass="header-testata" />
    <Evento />
    <div className="bg-fagioloni bg-fagioloni--offset">
      <div className="bg-fagioloni__left"></div>
      <div className="bg-fagioloni__right"></div>
      <Cosa />
      <Focus />
      <Partecipare />
      <Banner />
      <DiventaSponsor />
      {/* <WcIIC /> */}
      {/* <Newsletter /> */}
    </div>
  </Layout>
);

export default EventoPage;
